import { BTableSimple } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBTableSimple = createEgBootstrapProxy(
  "EgBTableSimple",
  BTableSimple
);
